import React, { useState } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from "react-i18next";

function SupportRequests() {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState("");

    const columns = [
        { Header: t("Nom Complet"), accessor: "client", width: "15%" },
        { Header: t("Email"), accessor: "email", width: "15%" },
        { Header: t("Sujet"), accessor: "subject", width: "25%" },
        { Header: t("Message"), accessor: "message", width: "30%" },
        { Header: t("Date"), accessor: "date", width: "10%" },
    ];

    const initialRows = [
        {
            client: "Ahmed Ben Salah",
            email: "ahmed@example.com",
            subject: "Problème d'accès",
            message: "Je n'arrive pas à me connecter à mon compte depuis ce matin.",
            date: "2026-02-18",
        },
        {
            client: "Sonia Mansour",
            email: "sonia@example.com",
            subject: "Facturation",
            message: "Il y a une erreur sur ma dernière facture de réparation.",
            date: "2026-02-17",
        },
        {
            client: "Mohamed Dridi",
            email: "mohamed@example.com",
            subject: "Ajout Client",
            message: "Le bouton d'ajout de client ne répond pas sur mobile.",
            date: "2026-02-16",
        },
        {
            client: "Fatma Trabelsi",
            email: "fatma@example.com",
            subject: "Export CSV",
            message: "Comment puis-je exporter mes ventes mensuelles en CSV ?",
            date: "2026-02-18",
        },
    ];

    const filteredRows = initialRows.filter(
        (row) =>
            row.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.message.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                            <SoftTypography variant="h5" fontWeight="bold">
                                {t("Demandes de Support")}
                            </SoftTypography>
                            <SoftBox display="flex" alignItems="center">
                                <SoftBox width="15rem">
                                    <SoftInput
                                        placeholder={`${t("Rechercher")}...`}
                                        icon={{ component: "search", direction: "left" }}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                        <SoftBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                        >
                            <DataTable
                                table={{ columns, rows: filteredRows }}
                                entriesPerPage={false}
                                canSearch={false}
                                isSorted={false}
                                showTotalEntries={false}
                            />
                        </SoftBox>
                    </Card>
                </SoftBox>
            </SoftBox>
            <Footer />
        </DashboardLayout>
    );
}

export default SupportRequests;
